<template>
  <div id="app">
    <header v-if="needHeader">
      <v-header></v-header>
    </header>
    <div class="main"
      :style="{ height: contH }">
      <router-view />
    </div>
  </div>
</template>
<script>
  import VHeader from './views/VHeader.vue';

  export default {
    components: { VHeader },
    data() {
      return {
        curli: 'config'
      };
    },
    computed: {
      needHeader() {
        let list = ['/login'];
        return !list.includes(this.$route.path);
      },
      contH() {
        return this.needHeader ? 'calc(100% - 60px)' : '100%';
      }
    }
  };
</script>


<style lang="scss">
  $pryClr: #3399ff;
  $pryClrL: #5cadff;
  $pryClrD: #3091f2;
  $infoClr: #3399ff;
  $successClr: #00cc66;
  $wrnClr: #ff9900;
  $errorClr: #ff6600;
  $dividerClr: #e3e8ee;
  $bgc: #f5f7f9;
  $contentClr: #657180;
  $titleClr: #464c5b;
  $topHt: 60px;
  $spbd: #d7dde4 1px solid;

  * {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
  }

  html,
  body {
    position: relative;
    height: 100%;
    width: 100%;
    font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
  }

  #app {
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /*text-align: center;*/
    color: #2c3e50;
    position: relative;
    height: 100%;
    width: 100%;
  }

  header {
    height: $topHt;
    background-color: $pryClr;
  }

  .router-link-exact-active {
    color: #f56c6c !important;
    border-bottom: #f56c6c 2px solid;
  }

  .main {
    width: 100%;
    background-color: $bgc;
    overflow:hidden;
  }
</style>
